import { render, staticRenderFns } from "./FileDiffChunk.vue?vue&type=template&id=2db99afb&scoped=true&"
import script from "./FileDiffChunk.vue?vue&type=script&lang=js&"
export * from "./FileDiffChunk.vue?vue&type=script&lang=js&"
import style0 from "./FileDiffChunk.vue?vue&type=style&index=0&id=2db99afb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db99afb",
  null
  
)

export default component.exports